/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetStorefrontConfig200ResponseConfig } from './GetStorefrontConfig200ResponseConfig';
import {
    GetStorefrontConfig200ResponseConfigFromJSON,
    GetStorefrontConfig200ResponseConfigFromJSONTyped,
    GetStorefrontConfig200ResponseConfigToJSON,
    GetStorefrontConfig200ResponseConfigToJSONTyped,
} from './GetStorefrontConfig200ResponseConfig';
import type { CreateCatalogRequest } from './CreateCatalogRequest';
import {
    CreateCatalogRequestFromJSON,
    CreateCatalogRequestFromJSONTyped,
    CreateCatalogRequestToJSON,
    CreateCatalogRequestToJSONTyped,
} from './CreateCatalogRequest';

/**
 * 
 * @export
 * @interface GetStorefrontConfig200Response
 */
export interface GetStorefrontConfig200Response {
    /**
     * 
     * @type {Array<CreateCatalogRequest>}
     * @memberof GetStorefrontConfig200Response
     */
    brands: Array<CreateCatalogRequest>;
    /**
     * 
     * @type {GetStorefrontConfig200ResponseConfig}
     * @memberof GetStorefrontConfig200Response
     */
    config: GetStorefrontConfig200ResponseConfig;
}

/**
 * Check if a given object implements the GetStorefrontConfig200Response interface.
 */
export function instanceOfGetStorefrontConfig200Response(value: object): value is GetStorefrontConfig200Response {
    if (!('brands' in value) || value['brands'] === undefined) return false;
    if (!('config' in value) || value['config'] === undefined) return false;
    return true;
}

export function GetStorefrontConfig200ResponseFromJSON(json: any): GetStorefrontConfig200Response {
    return GetStorefrontConfig200ResponseFromJSONTyped(json, false);
}

export function GetStorefrontConfig200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStorefrontConfig200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'brands': ((json['brands'] as Array<any>).map(CreateCatalogRequestFromJSON)),
        'config': GetStorefrontConfig200ResponseConfigFromJSON(json['config']),
    };
}

export function GetStorefrontConfig200ResponseToJSON(json: any): GetStorefrontConfig200Response {
    return GetStorefrontConfig200ResponseToJSONTyped(json, false);
}

export function GetStorefrontConfig200ResponseToJSONTyped(value?: GetStorefrontConfig200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'brands': ((value['brands'] as Array<any>).map(CreateCatalogRequestToJSON)),
        'config': GetStorefrontConfig200ResponseConfigToJSON(value['config']),
    };
}

